export const GET_MATERIALS_BY_MODEL = "GET_MATERIALS_BY_MODEL";
export const GET_MATERIALS_BY_NAME = "GET_MATERIALS_BY_NAME";